import React, { Component } from "react";
import { Col, Row, Container, Media } from "reactstrap";
import { joinCss } from "../../helpers/utils";
import { getFileLinkWithPage } from "../../helpers/utils";

import fixImg from "../../images/fixPaper.png";
import editionImg from "../../images/editionSearch.png";

import appClasses from "../../App.module.scss";

import ResultText from "./ResultText";
import MoreResults from "./MoreResults";
import ResultDataRow from "./ResultDataRow";

class Result extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.openPdf = this.openPdf.bind(this);
    this.state = {
      collapse: false
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  openPdf(url) {
    const newWin = window.open();
    const html = "<PdfViewer pdfUrl={url} />";
    newWin.document.write(html);
    //ReactDOM.createPortal();
  }

  render() {
    const result = this.props.result;
    const dataArr =
      result.highlight["data.melingo"] != undefined
        ? result.highlight["data.melingo"]
        : result.highlight["data.raw"];
    return (
      <div>
        <Row
          key={this.props.index}
          className={joinCss(
            appClasses.resultLine,
            "mb-4",
            appClasses["vertical-center-parent"]
          )}
        >
          <Container>
            <a
              className={appClasses.resultContantLink}
              target="_blank"
              href={getFileLinkWithPage(
                result.hit.docIdentity,
                result.hit.pdfName,
                result.hit.page
              )}
            >
              <Row>
                <Col lg="1" sm="2" className={appClasses.rightCol}>
                  <Media
                    className="px-1 pt-4"
                    src={result.hit.docParentID === "" ? editionImg : fixImg}
                    alt="מסמך"
                  />
                  <div className={appClasses.imgTitle}>
                    {result.hit.docParentID === "" ? "מהדורה" : "דף תיקון"}
                  </div>
                </Col>
                <Col lg="11" sm="10">
                  <ResultText result={result} displayPageOnly={false} />
                </Col>
              </Row>
            </a>
            <ResultDataRow
              resultsLength={dataArr.length}
              publishAt={result.hit.publishAt}
              toggleHeandler={() => this.toggle()}
            />
          </Container>
        </Row>
        <MoreResults
          isOpen={this.state.collapse}
          closeHeandler={() => this.toggle()}
          list={dataArr}
          result={result}
        />
      </div>
    );
  }
}

export default Result;
